import { Page } from 'api/contentful/contentTypes.cloverdotcom';
import { FlatEntry } from 'services/cms/flattenContentful';

export function isInternalPath(slug = '', items: Array<Partial<FlatEntry<Page>>> = []) {
  if (!slug) return false;

  // Exclude search query and hash
  slug = slug.split('?')[0].split('#')[0];

  return items.some(item => item?.slug && slug.startsWith(item.slug, 1));
}
